import './Card.css';

const Card = ({ project }) => {
  const { name, image, description, website, about } = project;

  return (
    <div className="wrap">
      <div className="flipBox">
        <div className="flipBoxInner">
          <div className="flipBoxFront">
            <img src={image} alt={name} />
          </div>
          <div className="flipBoxBack">
            <h3>{name}</h3>
            <p>{description}</p>
            <div className="links">
              <a className="link" href={website}>
                View
              </a>
              <a className="link" href={about}>
                About
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
